import type { IResponse, RequestConfig } from '../interface/common';
import { fetch } from '../request';
import type {
  IGetCodeBody,
  IPublishBody,
  IPublishListBody,
  ISendAuthRes,
  ISendCodeBody,
  IGetProcessRes,
  UserPublishItem,
  IPublishBodyForeign,
} from '../interface/publish';

// 查询授权信息
export const getPublishCode = (params?: IGetCodeBody) => {
  return fetch<IResponse<{ results: UserPublishItem[] }>>('/share/check_auth_status/', {
    method: 'GET',
    params,
  });
};

// 提交授权code信息
export const sendPublishCode = (data: ISendCodeBody) => {
  return fetch<IResponse<ISendAuthRes>>('/share/access_token_auth_action/', {
    method: 'POST',
    body: data,
  });
};

// 删除授权code信息
export const delPublishAuth = (data: ISendCodeBody) => {
  return fetch<IResponse>('/share/cancel_auth/', {
    method: 'POST',
    body: data,
  });
};

// 获取B站分区信息
export const getBliBliArea = () => {
  return fetch<IResponse<{ area_info: UserPublishItem[] }>>('/share/bilibili_area_info/', {
    method: 'POST',
  });
};

// 发布分享
export const createPublish = (data: IPublishBody) => {
  return fetch<IResponse>('/share/submit_share/', {
    method: 'POST',
    body: data,
  });
};

/** 海外分享 */
export const createPublishForeign = (data: IPublishBodyForeign) => {
  return fetch<IResponse>('/share/submit_abroad_share/', {
    method: 'POST',
    body: data,
  });
};

// 查询分享结果
export const getPublishList = (params: IPublishListBody) => {
  return fetch<IResponse<{ results: IGetProcessRes[] }>>('/share/check_share/', {
    method: 'GET',
    params,
  });
};

// 取消分享
export const cancelPublish = (data: { id: number }) => {
  return fetch<IResponse>('/share/cancel_share/', {
    method: 'POST',
    body: data,
  });
};
